import { useBemCN } from '@gik/core/utils/bemBlock';
import React from 'react';
import SvgIcon, { HeroIconName } from '../SvgIcon';
import { UISize } from '../types';

export interface IArrowButtonProps {
  disabled: boolean;
  onClick(): void;
  className?: string;
  size?: UISize;
}

interface IInternalArrowButtonProps extends IArrowButtonProps {
  elementName: string;
  iconName: HeroIconName;
}

function ArrowButton({
  disabled,
  elementName,
  iconName,
  className,
  onClick,
  size,
}: IInternalArrowButtonProps): React.ReactElement {
  const bem = useBemCN('arrow-button');
  // TODO: move disabled into modifiers
  return (
    <div
      {...bem(
        elementName,
        [
          {
            [`size-${size}`]: size,
          },
        ],
        [{ disabled }, className]
      )}
      onClick={() => {
        !disabled && onClick?.();
      }}
    >
      <SvgIcon name={iconName} size={size} />
    </div>
  );
}

export function ArrowButtonNext(props: IArrowButtonProps) {
  return <ArrowButton iconName="ChevronRight" elementName="next" {...props} />;
}

export function ArrowButtonPrev(props: IArrowButtonProps) {
  return <ArrowButton iconName="ChevronLeft" elementName="prev" {...props} />;
}
